import React from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';
import { Glyphicon } from 'react-bootstrap';

const checkedIcon = (
  <Glyphicon style={{ color: 'white', left: '10px', top: '6px' }} glyph="lock"/>
);

const CargomaticSwitch = ({ className, checked, onChange, offColor, checkedIcon, uncheckedIcon, height, width, disabled }) => (
  <Switch
    className={className}
    disabled={disabled}
    checked={checked}
    onChange={onChange}
    offColor={offColor}
    checkedIcon={checkedIcon}
    uncheckedIcon={uncheckedIcon}
    height={height}
    width={width}
  />
)

CargomaticSwitch.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  offColor: PropTypes.string,
  checkedIcon: PropTypes.object || PropTypes.bool,
  uncheckedIcon: PropTypes.object || PropTypes.bool,
};

CargomaticSwitch.defaultProps = {
  offColor: '#C53030',
  height: 28,
  width: 56,
  checkedIcon,
};

export default CargomaticSwitch;
